// extracted by mini-css-extract-plugin
export var grid = "ProductBlock-module--grid--3z7l-";
export var show = "ProductBlock-module--show--2bnKt";
export var showFadeInDown = "ProductBlock-module--show-fade-in-down--2Jox6";
export var showFadeInUp = "ProductBlock-module--show-fade-in-up--2Ufr9";
export var hideFadeOut = "ProductBlock-module--hide-fade-out--putDq";